module.exports = __webpack_public_path__ + "media/images/icons/country_flags/uz-7ed400a6435c85b5b8900c1bb9dc79d8.svg";